import React, { Component } from 'react';
import axios from 'axios';
import Autosuggest from '@UI/Autosuggest';
import ClearButton from '@Components/ClearButton';
import { injectIntl } from 'react-intl';
import t from 'prop-types';

class LocationField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActiveGsp: !!this.getFullLocation(),
      location: this.getFullLocation(),
      locations: [this.getFullLocation()],
    };
  }

  /**
   * Called right after updating occurs. Not called for the initial render.
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    const { searchParams } = this.props;
    if (searchParams.city !== prevProps.searchParams.city) {
      this.setState({
        location: this.getFullLocation(),
        isActiveGsp: !!this.getFullLocation(),
      });
    }
  }

  /**
   * Handle Location field updates
   * @param value {String}
   */
  onLocationChange = (value) => {
    if (value) {
      axios.get(`${process.env.REACT_APP_APIGEE_LAMBDA_ENDPOINT}/locations-autocomplete`, {
        params: {
          apikey: typeof window !== 'undefined' ? window.apigeeKey : '',
          text: value.trim(),
          language: this.props.intl.locale,
        },
      }).then((response) => {
        const suggestions = response.data ? response.data.data : [];
        this.setState({ locations: suggestions });
        return suggestions;
      }).catch(() => {
        this.setState({ locations: [] });
        return [];
      });
    } else {
      this.setState({ locations: [] });
    }
  };

  /**
   * Add/Remove icon on location field
   * @param e
   */
  onLocationFieldBlur = (e) => {
    // Add active icon
    this.setState({ isActiveGsp: !!e.target.value.length });
  };

  /**
   * Format full location string, if location contains region then add comma
   * between City and Location, otherwise return City name.
   * @return {string}
   */
  getFullLocation = () => (this.props.searchParams.region
    ? `${this.props.searchParams.city}, ${this.props.searchParams.region}`
    : this.props.searchParams.city);

  /**
   * Clear Location state
   */
  clearLocationField = () => {
    this.setState({ location: '', locations: [] });
  };

  render() {
    const {
      intl, cssClasses, id, highlightError, renderError,
    } = this.props;
    const { location, locations, isActiveGsp } = this.state;

    return (
      <div className={`form-group ${cssClasses} ${highlightError}`}>
        <div
          className={`form-group__input form-group__input--button clearable-input ${isActiveGsp ? 'clearable-input--active' : ''}`}
          data-search-location
          data-rs-clearable
        >
          <div className={`${isActiveGsp ? 'form-group__location--active' : ''} `}>
            <span className={`icon icon__gsp fill-brand--${process.env.REACT_APP_COUNTRY === 'sph' ? 'orange' : 'blue'}`}>
              <svg aria-label={intl.formatMessage({ id: 'Icon.GPS.AriaLabel' })}>
                <use
                  xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#gps-filled"
                />
              </svg>
            </span>
            <Autosuggest
              name="where"
              id={id}
              required
              placeholder={intl.formatMessage({ id: 'Form.LocationPlaceholder' })}
              label={intl.formatMessage({ id: 'Form.LocationLabel' })}
              initialValue={location}
              items={locations}
              config={{ skipFilter: true }}
              data-rs-input-highlight
              onChange={this.onLocationChange}
              onSelectItem={this.onLocationChange}
              onBlur={this.onLocationFieldBlur}
              noResultsText={intl.formatMessage({ id: 'Form.Autocomplete.NoResults' })}
            />
            <ClearButton clearField={this.clearLocationField} />
            {renderError}
          </div>
        </div>
      </div>
    );
  }
}

LocationField.propTypes = {
  cssClasses: t.string,
  highlightError: t.string,
  id: t.string.isRequired,
  renderError: t.oneOfType([t.element, t.string]),
  searchParams: t.shape({
    region: t.string,
    city: t.string,
  }),
};

LocationField.defaultProps = {
  cssClasses: '',
  highlightError: '',
  renderError: '',
  searchParams: {
    region: '',
    city: '',
  },
};

export default injectIntl(LocationField);
